import { motion } from "framer-motion";

export default function NebulaBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-b from-bg-950 via-bg-900 to-bg-950" />
      <motion.div
        className="absolute -top-1/3 -left-1/4 w-[60vw] h-[60vw] rounded-full blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(96,165,250,0.22), transparent 60%)" }}
        animate={{ x: [0, 60, -40, 0], y: [0, -30, 50, 0], scale: [1, 1.08, 0.96, 1] }}
        transition={{ duration: 38, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-1/3 -right-1/4 w-[55vw] h-[55vw] rounded-full blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(167,139,250,0.20), transparent 60%)" }}
        animate={{ x: [0, -50, 40, 0], y: [0, 40, -30, 0], scale: [1, 0.94, 1.06, 1] }}
        transition={{ duration: 44, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[40vw] h-[40vw] rounded-full blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(34,211,238,0.10), transparent 60%)" }}
        animate={{ x: [-20, 30, -10, -20], y: [-10, 20, -30, -10], scale: [1, 1.05, 0.98, 1] }}
        transition={{ duration: 52, repeat: Infinity, ease: "easeInOut" }}
      />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140vmax] h-[140vmax] opacity-[0.04] animate-spin-slower"
        style={{
          background:
            "conic-gradient(from 0deg at 50% 50%, rgba(96,165,250,0.6), rgba(167,139,250,0.5), rgba(34,211,238,0.4), rgba(232,121,249,0.5), rgba(96,165,250,0.6))",
          maskImage: "radial-gradient(closest-side, black 30%, transparent 75%)",
          WebkitMaskImage: "radial-gradient(closest-side, black 30%, transparent 75%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            "radial-gradient(1px 1px at 20% 30%, rgba(255,255,255,0.6), transparent), \
             radial-gradient(1px 1px at 67% 81%, rgba(255,255,255,0.5), transparent), \
             radial-gradient(1.5px 1.5px at 41% 12%, rgba(186,213,255,0.6), transparent), \
             radial-gradient(1px 1px at 88% 47%, rgba(255,255,255,0.4), transparent), \
             radial-gradient(1px 1px at 9% 79%, rgba(255,230,180,0.5), transparent), \
             radial-gradient(1.5px 1.5px at 55% 60%, rgba(255,255,255,0.5), transparent)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 50%, rgba(3,6,13,0.65) 100%)",
        }}
      />
    </div>
  );
}
